import { ImageTransformOptions, contentfulImageLoader } from "@utils/imageLoader";
import React, { ComponentPropsWithoutRef, FC, useState } from "react";

interface Props extends Omit<ComponentPropsWithoutRef<"img">, "height" | "width">, ImageTransformOptions {
  src: string;
  alt: string;
  className?: string;
}
const Image: FC<Props> = ({ src, width, alt, className, ...rest }) => {
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const srcSet = [1, 2].map((dpr: number) => {
    const props = {
      src,
      ...rest,
      width: width * dpr,
      height: rest?.height ? rest?.height * dpr : undefined,
    };
    return `${contentfulImageLoader(props)} ${dpr}x`;
  });
  return (
    <img
      loading={rest?.loading ?? "lazy"}
      width={width}
      height={rest?.height}
      // onLoad={() => setIsLoading(false)}
      className={className}
      srcSet={srcSet.join(", ")}
      alt={alt}
    />
  );
};
export default Image;
